import React from 'react';

/**
 * DataTableEllipsisText component for displaying text with ellipsis and tooltip
 * @param {string} value - The value to display
 * @returns {JSX.Element}
 */
function DataTableEllipsisText({ value }) {
    const text = value === null || value === undefined ? '' : String(value);

    return (
        <span
            className="data-table-ellipsis-text"
            title={text}
            style={{
                display: 'block',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}
        >
            {text}
        </span>
    );
}

export default DataTableEllipsisText;
